export const errorImage: string = '/img/image-not-found.webp'
export const statamicGraphqlEndpoint =
  process.env.NEXT_PUBLIC_GQL_STATAMIC || 'https://api.debossgarage.com/graphql'
export const laravelGraphqlEndpoint =
  process.env.NEXT_PUBLIC_GQL_LARAVEL ||
  'https://api.debossgarage.com/api/graphql-lighthouse'
